import { Link } from "react-router-dom";
import { Reveal } from "../Reveal";

export const CTABanner = ({ title = "Ready for IT that just works?", sub = "Book a free consultation. We'll look at your setup, tell you plainly what we'd change, and quote the Sempresera Standard for your team." }) => (
  <section className="border-t border-white/5" data-testid="cta-banner">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal>
        <h2 className="max-w-4xl font-display text-4xl font-black leading-[1.02] tracking-tighter text-white md:text-6xl lg:text-7xl">
          {title}
        </h2>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#C9D2DE] md:text-lg">{sub}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/contact?mode=book" className="btn-primary" data-testid="cta-book-button">Book a free consultation</Link>
          <Link to="/contact" className="btn-ghost" data-testid="cta-contact-button">Send a message</Link>
        </div>
      </Reveal>
    </div>
  </section>
);
